/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { forwardRef } from 'react';
import ArrowLeft from '@atlaskit/icon/glyph/arrow-left';
import ArrowRight from '@atlaskit/icon/glyph/arrow-right';
import { MediaFilmStripListItemSelector } from '.';
import { css } from '@emotion/react';
import { N20, N40, B400, B50 } from '@atlaskit/theme/colors';
const filmStripViewStyles = css({
  position: 'relative',
  padding: `${"var(--ds-space-025, 3px)"} 0`,
  borderRadius: '3px',
  '&:hover .arrow': {
    opacity: 1
  },
  '.ellipsed-text': {
    whiteSpace: 'initial'
  }
});
const filmStripListWrapperStyles = css({
  width: 'inherit',
  overflow: 'hidden',
  padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-025, 3px)"}`
});
const filmStripListStyles = css({
  margin: 0,
  padding: 0,
  transitionProperty: 'transform',
  transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
  whiteSpace: 'nowrap',
  display: 'inline-block'
});
const filmStripListItemStyles = css({
  listStyleType: 'none',
  margin: 0,
  padding: `0 ${"var(--ds-space-050, 4px)"}`,
  ':first-child': {
    paddingLeft: 0
  },
  display: 'inline-block',
  verticalAlign: 'middle',
  fontSize: 0
});
const arrowWrapperStyles = css({
  position: 'absolute',
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: `var(--ds-surface-overlay, ${N20})`,
  borderRadius: '100%',
  display: 'flex',
  cursor: 'pointer',
  transition: 'opacity 0.3s',
  boxShadow: "var(--ds-shadow-overlay, 0 1px 6px 0 rgba(0, 0, 0, 0.6))",
  color: "var(--ds-icon, black)",
  width: '30px',
  height: '30px',
  justifyContent: 'center',
  opacity: 0,
  '&:hover': {
    color: "var(--ds-text-subtle, black)",
    backgroundColor: `var(--ds-surface-overlay-hovered, ${N40})`
  },
  '&:active': {
    color: `var(--ds-text-selected, ${B400})`,
    backgroundColor: `var(--ds-background-selected, ${B50})`
  },
  svg: {
    height: '30px',
    width: '20px'
  }
});
const arrowLeftWrapperStyles = css(arrowWrapperStyles, {
  left: "var(--ds-space-100, 8px)",
  svg: {
    paddingRight: "var(--ds-space-025, 2px)"
  }
});
const arrowRightWrapperStyles = css(arrowWrapperStyles, {
  right: "var(--ds-space-100, 8px)",
  svg: {
    paddingLeft: "var(--ds-space-025, 2px)"
  }
});
const shadowStyles = css({
  position: 'absolute',
  zIndex: 10,
  height: '100%',
  top: 0,
  width: '2px',
  backgroundColor: "var(--ds-border, rgba(0, 0, 0, 0.2))"
});
const shadowLeftStyles = css(shadowStyles, {
  left: 0
});
const shadowRightStyles = css(shadowStyles, {
  right: 0
});
const ShadowLeft = ({
  children
}) => jsx("div", {
  css: shadowLeftStyles
}, children);
export const ArrowLeftWrapper = ({
  children,
  onClick
}) => jsx("div", {
  css: arrowLeftWrapperStyles,
  className: "arrow",
  onClick: onClick
}, children);
export const ShadowRight = ({
  children
}) => jsx("div", {
  css: shadowRightStyles
}, children);
export const ArrowRightWrapper = ({
  children,
  onClick
}) => jsx("div", {
  css: arrowRightWrapperStyles,
  className: "arrow",
  onClick: onClick
}, children);
export const LeftArrow = ({
  onClick
}) => jsx(ShadowLeft, null, jsx(ArrowLeftWrapper, {
  onClick: onClick
}, jsx(ArrowLeft, {
  label: "left"
})));
export const RightArrow = ({
  onClick
}) => jsx(ShadowRight, null, jsx(ArrowRightWrapper, {
  onClick: onClick
}, jsx(ArrowRight, {
  label: "right"
})));
export const FilmStripViewWrapper = ({
  children,
  'data-testid': dataTestId
}) => jsx("div", {
  css: filmStripViewStyles,
  "data-testid": dataTestId
}, children);
export const FilmStripListWrapper = /*#__PURE__*/forwardRef(({
  children,
  onWheel,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  'data-testid': dataTestId
}, ref) => jsx("div", {
  css: filmStripListWrapperStyles,
  ref: ref,
  onWheel: onWheel,
  onTouchStart: onTouchStart,
  onTouchMove: onTouchMove,
  onTouchEnd: onTouchEnd,
  "data-testid": dataTestId
}, children));
export const FilmStripList = /*#__PURE__*/React.forwardRef(({
  children,
  style
}, ref) => jsx("ul", {
  css: filmStripListStyles,
  ref: ref,
  style: style
}, children));
export const FilmStripListItem = ({
  children,
  index
}) => jsx("li", {
  css: filmStripListItemStyles,
  className: MediaFilmStripListItemSelector,
  "data-testid": "media-filmstrip-list-item",
  key: index
}, children);